import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Open In new"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-open-in-new',
    templateUrl: './icon-open-in-new.component.html',
    styleUrls: ['./icon-open-in-new.component.scss'],
    standalone: false
})
export class IconOpenInNewComponent  {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
